/**
 * An object containing properties for sort events
 */
var SortEvent = /** @class */ (function () {
    function SortEvent() {
    }
    return SortEvent;
}());
export { SortEvent };
//# sourceMappingURL=sort-event.js.map